// src/utils/debouncedToastService.ts

import { toastService } from './toastService';

class DebouncedToastService {
    private lastToasterTimes: Map<string, number> = new Map();
    private readonly DEBOUNCE_TIME = 3000;

    private canShowToast(toasterKey: string): boolean {
        const now = Date.now();
        const lastTime = this.lastToasterTimes.get(toasterKey) || 0;

        if (now - lastTime > this.DEBOUNCE_TIME) {
            this.lastToasterTimes.set(toasterKey, now);
            return true;
        }
        return false;
    }

    error(message: string, key?: string) {
        const toasterKey = key || message;
        if (this.canShowToast(toasterKey)) {
            toastService.error(message);
        }
    }

    success(message: string, key?: string) {
        const toasterKey = key || message;
        if (this.canShowToast(toasterKey)) {
            toastService.success(message);
        }
    }

    warning(message: string, key?: string) {
        const toasterKey = key || message;
        if (this.canShowToast(toasterKey)) {
            toastService.warn?.(message);
        }
    }

    info(message: string, key?: string) {
        const toasterKey = key || message;
        if (this.canShowToast(toasterKey)) {
            toastService.info?.(message);
        }
    }

    clearCache() {
        this.lastToasterTimes.clear();
    }
}

export const debouncedToastService = new DebouncedToastService();
